import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationService, SubscriptionCollector } from '@draeger-academy/common';
import { ResponsiveState } from '@viablelogic/ngx-responsive';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'da-site-navigation',
    templateUrl: './site-navigation.component.html',
    styleUrls: ['./site-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteNavigationComponent implements OnInit, OnDestroy {
    public navigationData: any[] = [];
    @SubscriptionCollector() private _subscriptions;
    private _$isMobile: BehaviorSubject<boolean> = new BehaviorSubject(undefined);
    private _$navigationTranslations: BehaviorSubject<object> = new BehaviorSubject({});

    constructor(
        private _navigationService: NavigationService,
        private _navigationMockService: NavigationService,
        public responsiveState: ResponsiveState,
        protected _ref: ChangeDetectorRef
    ) {}

    public get isMobile$(): Observable<boolean> {
        return this._$isMobile.asObservable();
    }

    public get navigationTranslations$(): Observable<object> {
        return this._$navigationTranslations.asObservable();
    }

    ngOnInit() {
        // this._navigationService.navigationObj$.subscribe((data) => {
        //     if (data) {
        //         this.navigationData = data;
        //     }
        // });
        this._navigationMockService.navigationObj$.subscribe((data) => {
            if (data) {
                this.navigationData = data;
            }
        });
        // this._$navigationTranslations.next(this._translationService.getAllTranslations('DwCommon'));
        this._checkIfViewportIsSmall();
    }

    ngOnDestroy() {
        this._subscriptions.forEach((data) => {
            if (data) {
                data.unsubscribe();
            }
        });
    }

    private _checkIfViewportIsSmall() {
        this._subscriptions.push(
            this.responsiveState.elemento$.pipe(distinctUntilChanged()).subscribe((val) => {
                this._$isMobile.next(val === 'xs' || val === 'sm');
            })
        );
    }
}
